const getDefaultState = () => ({
  areas: {
    items: null,
    loading: false,
    error: null,
  },
  facts: {
    items: null,
    loading: false,
    error: null,
    area: null,
    units: null,
  },
  area: null,
  snowGuarantee: {
    active: false,
    title: null,
    description: null,
    loading: null,
    area: null,
    error: null,
  },
  slopeMaps: {
    items: [],
    loading: false,
    error: false,
  },
  slopeMap: {
    loading: false,
    error: false,
  },
  pickupPlaces: {
    items: [],
    loading: false,
    error: false,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/ski/areas/defaultState.js